module.exports = __webpack_public_path__ + "static/media/brandstore.229eb320.webp";